
import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import listSearch from '@/pages/list-search'
import service from '@/pages/service'
import online_class from '@/pages/online_class'
import userInfo from '@/pages/user/user-info'
import PhoneNum from '@/pages/user/user-phoneNum'
import NewpassWord from '@/pages/user/user-Newpassword'
import userOffline from '@/pages/user/user-offline'
import userLiveclass from '@/pages/user/user-Liveclass'
import userTimetable from '@/pages/user/user-timetable'
import userOrder from '@/pages/user/user-order'
import userOrderListDetail from '@/pages/user/order-list-detail'
import orderRefund from '@/pages/user/order-list-detail'
import videoPlay from '@/pages/user/record-video-play'
import liveClass from '@/pages/live-class'
import liveDetail from '@/pages/live-class-detail'
import feedback from '@/pages/about-user/feedback'
import userDown from '@/pages/user/user-down'
import orderDetail from '@/pages/user/user-order-detail'
import orderPaydetail from '@/pages/user/order-payment-detail'
import brief from '@/pages/about-user/brief'
import list_detail from '@/pages/list-detail'
import purchase from '@/pages/payment'
import Livedetail from '@/pages/user/user-live-detail'
import userBorder from '@/pages/user/user-b-order'
import userCorder from '@/pages/user/user-c-order'
import userDorder from '@/pages/user/user-d-order'
import term from '@/pages/term'
import zs from '@/pages/zs'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    {
      path: '/online_class',
      name: 'online_class',
      component: online_class
    },
    {
      path: '/user/userInfo',
      name: 'userInfo',
      component: userInfo
    },
    {
      path: '/list-detail',
      name: 'list-detail',
      component: list_detail
    },{
      path: '/user/newpassword',
      name: 'NewpassWord',
      component: NewpassWord
    },{
      path: '/user/phonenum',
      name: 'PhoneNum',
      component: PhoneNum
    },{
      path: '/user/userOffline',
      name: 'userOffline',
      component: userOffline
    }, {
      path: '/user/userLiveclass',
      name: 'userLiveclass',
      component: userLiveclass
    }, {
      path: '/user/userTimetable',
      name: 'userTimetable',
      component:userTimetable
    },{
      path: '/user/userOrder',
      name: 'userOrder',
      component: userOrder
    },{
      path: '/user/userOrderListDetail',
      name: 'userOrderListDetail',
      component: userOrderListDetail
    }, {
      path: '/user/videoPlay',
      name: 'videoPlay',
      component: videoPlay
    }, {
      path: '/user/down',
      name: 'user-down',
      component: userDown
    },  {
      path: '/user/orderDetail',
      name: 'orderDetail',
      component: orderDetail
    }, {
      path: '/aboutuser/feedback',
      name: 'feedback',
      component: feedback
    },{
      path: '/aboutuser/brief',
      name: 'brief',
      component: brief
    },{
      path: '/user/Livedetail',
      name: 'user-Livedetail',
      component: Livedetail
    },{
      path: '/payment',
      name: 'purchase-course',
      component: purchase
    },
    {
      path: '/user/user-b-order',
      name: 'user-b-order',
      component: userBorder
    }, {
      path: '/user/user-c-order',
      name: 'user-c-order',
      component: userCorder
    },{
      path: '/user/user-d-order',
      name: 'user-d-order',
      component: userDorder
    }, {
      path: '/user/order-refund',
      name: 'order-refund',
      component:orderRefund
    },{
      path: '/live-class',
      name: 'live_class',
      component: liveClass
    }, {
      path: '/live-class-detail',
      name: 'live_detail_class',
      component: liveDetail
    }, {
      path: '/order-payment-detail',
      name: 'order-payment-detail',
      component: orderPaydetail
    },{
      path: '/list-search',
      name: 'list-search',
      component: listSearch
    },{
      path: '/term',
      name: 'term',
      component:term
    },{
      path: '/zs',
      name: 'zs',
      component:zs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js